import React from 'react';
import { Button, IconButton } from '@mui/joy';
import SvgIcon from '@mui/joy/SvgIcon';
import { styled } from '@mui/joy';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const VisuallyHiddenInput = styled('input')`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
`;

const InputFileUpload = ({ onChange = () => null, selectedFiles = [], setSelectedFiles }) => {

    // Function to remove a selected file
    const handleRemoveFile = (index) => {
        const updatedFiles = [...selectedFiles];
        updatedFiles.splice(index, 1);
        setSelectedFiles(updatedFiles);
    };

    return (
        <Box>
            <Button
                component="label"
                role={undefined}
                tabIndex={-1}
                variant="outlined"
                color={selectedFiles.length > 0 ? 'success' : 'neutral'}
                startDecorator={
                    <SvgIcon>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                            />
                        </svg>
                    </SvgIcon>
                }
            >
                {selectedFiles.length > 0 ? `${selectedFiles.length} file(s) selected` : "Upload files"}
                <VisuallyHiddenInput
                    type="file"
                    accept=".pdf,.jpeg,.jpg,.png,application/pdf,image/jpeg,image/jpg,image/png"
                    onChange={onChange}
                    multiple // ✅ Enables multiple file selection
                />
            </Button>

            {/* Display selected files with remove option */}
            {/* {selectedFiles.length > 0 && (
                <Box sx={{ mt: 1, p: 1, border: '1px solid', borderRadius: '8px', borderColor: 'neutral.outlinedBorder' }}>
                    {selectedFiles.map((file, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                            <Typography level="body2">{file.name}</Typography>
                            <IconButton size="sm" variant="plain" color="danger" onClick={() => handleRemoveFile(index)}>
                                <CloseRoundedIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    ))}
                </Box>
            )} */}
        </Box>
    );
};

export default InputFileUpload;
